import PropTypes from 'prop-types';

export const ChooseDomainStepProps = {
  locales: PropTypes.object.isRequired,
  requestChangeDomain: PropTypes.func,
  changeDomainLoading: PropTypes.bool,
  buttonsProps: PropTypes.shape({
    leftButton: PropTypes.object,
    rightButton: PropTypes.array,
  }),
  selectDomain: PropTypes.bool,
  showAutoCompleteDomain: PropTypes.bool,
  autoCompleteOptions: PropTypes.array,
  autoCompleteDomain: PropTypes.func,
  setShowAutoCompleteDomain: PropTypes.func,
  domainMessageError: PropTypes.string,
  domainMessageErrorBr: PropTypes.string,
  insideWizard: PropTypes.bool,
  userDomainsList: PropTypes.array,
  selectedDomain: PropTypes.string,
  setSelectedDomain: PropTypes.func,
  handleContinueInsideWizard: PropTypes.func,
  loadingSites: PropTypes.bool,
  loadingVerifyIfSiteExist: PropTypes.bool,
  hasMultDomainPlans: PropTypes.bool,
};
